class AjaxCartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();
      this.closest("ajax-cart").updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define("ajax-cart-remove-button", AjaxCartRemoveButton);

class AjaxCart extends HTMLElement {
  constructor() {
    super();
    if (window.location.pathname === "/cart") return;

    this.cart = document.querySelector(".ajax-cart");
    setTimeout(() => this.cart.classList.add("is-active"), 200);
    this.backdrop = document.querySelector(".ajax-cart__backdrop");
    this.close = document.querySelector(".ajax-cart__close");
    this.items = document.querySelector(".ajax-cart__items");
    this.summary = document.querySelector(".ajax-cart__summary");
    this.empty = document.querySelector(".ajax-cart__empty");
    this.openCartBtn = document.getElementById("cart-icon-bubble");
    this.html = document.getElementsByTagName("html")[0];
    this.subTotal = document.querySelector("[data-sub-total]");
    this.estShipping = document.querySelector("[data-est-shipping]");
    this.estTotal = document.querySelector("[data-est-total]");

    this.openCartBtn.addEventListener("click", this.onOpenCart.bind(this));
    this.backdrop.addEventListener("click", this.onCloseCart.bind(this));
    this.close.addEventListener("click", this.onCloseCart.bind(this));

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener("change", this.debouncedOnChange.bind(this));

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]')).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value);
  }

  updateQuantity(line, quantity) {
    const newQuantity = Math.min(quantity, QUANTITY_MAX);

    const body = JSON.stringify({
      line,
      quantity: newQuantity,
      sections: this.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    });

    this.enableLoading();
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.json();
      })
      .then((parsedState) => {
        this.renderContents(parsedState);
        this.updateLiveRegions(line, parsedState.item_count);
        this.disableLoading();
      })
      .catch(() => {
        this.disableLoading();
      });
  }

  enableLoading() {
    document.activeElement.blur();
    this.classList.add("ajax-cart__loading");
  }

  disableLoading() {
    this.classList.remove("ajax-cart__loading");
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      document.getElementById(`Line-item-error-${line}`).querySelector(".ajax-cart-product__error-text").innerHTML =
        window.cartStrings.quantityError.replace("[quantity]", document.getElementById(`Quantity-${line}`).value);
    }

    this.currentItemCount = itemCount;
  }

  updateLiveRegionsByVariantId(variantId, addedItemCount, isLimitReached) {
    this.currentItemCount += addedItemCount;
    if (isLimitReached) {
      const lineError = document.querySelector(`.ajax-cart-product__error[data-variant-id='${variantId}']`);
      const quantityElem = document.querySelector(`.quantity__input[data-variant-id='${variantId}']`);
      if (!lineError || !quantityElem) return;
      const errorText = lineError.querySelector(".ajax-cart-product__error-text");
      errorText.innerHTML = window.cartStrings.quantityError.replace("[quantity]", quantityElem.value);
    }
  }

  onOpenCart(event) {
    event.preventDefault();
    this.openCart();
  }

  onCloseCart(event) {
    event.preventDefault();
    this.closeCart();
  }

  renderContents(parsedState) {
    if (parsedState.item_count === 0) this.showEmpty();
    else this.hideEmpty();

    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id]);
    });
  }

  formatMoney(money) {
    const moneyString = money.toString();
    return `$${moneyString.substring(0, moneyString.length - 2)}.${moneyString.substring(
      moneyString.length - 2,
      moneyString.length
    )}`;
  }

  getSectionsToRender() {
    return [
      { id: "ajax-cart-product", selector: `#ajax-cart-product-${this.productId}` },
      { id: "cart-icon-bubble" },
      { id: "ajax-cart-total" },
      { id: "ajax-cart-free-shipping" },
      { id: "ajax-cart-delivery-date" },
    ];
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
  }

  openCart() {
    this.backdrop.classList.add("is-visible");
    this.cart.classList.add("is-visible");
    this.html.classList.add("no-scroll");
  }

  closeCart() {
    this.backdrop.classList.remove("is-visible");
    this.cart.classList.remove("is-visible");
    this.html.classList.remove("no-scroll");
  }

  showEmpty() {
    this.items.classList.remove("is-visible");
    this.summary.classList.remove("is-visible");
    this.empty.classList.add("is-visible");
  }

  hideEmpty() {
    this.items.classList.add("is-visible");
    this.summary.classList.add("is-visible");
    this.empty.classList.remove("is-visible");
  }
}

customElements.define("ajax-cart", AjaxCart);
